import { IScreenHighlight } from '../interfaces/screen-highlight.interface';

export const INVALID_SCREEN_HIGHLIGHT: IScreenHighlight = { label: 'Invalid', x0: NaN, y0: NaN, x1: NaN, y1: NaN };
